import React, { useEffect, useState } from "react";
import Select from "react-select";
import { FileText, Tags, Trash2, X, CheckCircle, Upload, Edit3 } from "lucide-react";

export const DocumentEditModal = ({
                                      fileName,
                                      visible,
                                      onConfirm,
                                      onCancel,
                                      fileTypeOptions,
                                      isEditMode = false,
                                      onDelete
                                  }: {
    fileName: string;
    visible: boolean;
    onConfirm: (name: string, fileType: string) => void;
    onCancel: () => void;
    fileTypeOptions: { value: string; label: string }[];
    isEditMode?: boolean;
    onDelete?: () => void;
}) => {
    const [name, setName] = useState("");
    const [selectedType, setSelectedType] = useState(fileTypeOptions[0]);

    useEffect(() => {
        setName(fileName);
    }, [fileName, fileTypeOptions]);

    if (!visible) return null;

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        if (name.trim() && selectedType) {
            onConfirm(name.trim(), selectedType.value);
            setName("");
        }
    };

    const handleCancel = () => {
        onCancel();
        setName("");
    };

    const handleDelete = () => {
        if (!onDelete) return;
        const confirmed = window.confirm("Are you sure you want to delete this file?");
        if (confirmed) {
            onDelete();
        }
    };

    return (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {isEditMode ? (
                                <Edit3 className="me-2" size={18} />
                            ) : (
                                <FileText className="me-2" size={18} />
                            )}
                            {isEditMode ? "Redigera filen" : "Information om filen"}
                        </h5>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="fileName" className="form-label">
                                    <FileText className="me-1" size={14} />
                                    Namn
                                </label>
                                <input
                                    id="fileName"
                                    type="text"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Ange filnamn"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">
                                    <Tags className="me-1" size={14} />
                                    Kategori
                                </label>
                                <Select
                                    options={fileTypeOptions}
                                    value={selectedType}
                                    onChange={(val) => {
                                        if (val) setSelectedType(val);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            {isEditMode && onDelete && (
                                <button 
                                    type="button" 
                                    className="btn btn-outline-danger me-auto"
                                    onClick={handleDelete}
                                >
                                    <Trash2 className="me-1" size={14} />
                                    Radera
                                </button>
                            )}

                            <button 
                                type="button" 
                                className="btn btn-secondary"
                                onClick={handleCancel}
                            >
                                <X className="me-1" size={14} />
                                Avbryt
                            </button>
                            <button 
                                type="submit" 
                                className="btn btn-primary"
                            >
                                {isEditMode ? (
                                    <CheckCircle className="me-1" size={14} />
                                ) : (
                                    <Upload className="me-1" size={14} />
                                )}
                                {isEditMode ? "Spara" : "Ladda upp"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
